import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isNonEmptyArray } from "../../../../../../../utils";
import HistoryRow from "./HistoryRow";
import styles from "./HistoryTab.module.css";
import { EmptyState } from "../../../../../../empties";
import { translate } from "../../../../../../../providers";

const HistoryTab = ({ element, onGetHistory, historyHeaderTitleKey = "", onRollbackAgentResults = null }) => {
	const projectId = useSelector(({ context }) => context.project?.id);
	const [history, setHistory] = useState([]);
	useEffect(() => {
		if (typeof onGetHistory === "function") {
			onGetHistory({ thematicId: element?.id, projectId })
				.then((data) => {
					setHistory(data);
				})
				.catch(console.error);
		}
	}, [element, projectId, onGetHistory]);

	return (
		<div className={styles.container}>
			{(isNonEmptyArray(history) &&
				history.map((item) => (
					<HistoryRow
						category={element}
						historyHeaderTitleKey={historyHeaderTitleKey}
						row={item}
						onRollbackAgentResults={onRollbackAgentResults}
					/>
				))) || <EmptyState content={translate("common:categories.import-panel.empty-state")} />}
		</div>
	);
};

export default HistoryTab;
